/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ReadOnlyFlight.vue?vue&type=template&id=2cb4f440"
import script from "./ReadOnlyFlight.ts?vue&type=script&lang=js&external"
export * from "./ReadOnlyFlight.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports